"use strict";

var Step = {
  currentStep: 1,
  $form: undefined,
  previewFiles: [],
  taskID: undefined,
  distance: 150,
  callbackUrl: undefined,
  postTaskAsGuest: false,
  bookingPage: false,
  maxFileSize: 20000001,
  maxVideoSize: 100000005,
  taskPosted: false,
  showConfirmPhotoPopup: true,
  validateStepInProgress: false,
  onload: document.addEventListener('DOMContentLoaded', function () {
    Step.init();
  }),
  init: function init() {
    this.bind();
    Client.getUserCountry();
  },
  bind: function bind() {
    $(document).on('change', '.form-step__input', function (event) {
      var div = $(this).closest('div');
      div.removeClass('form-step__input--error');
      div.find('div.form-step__error').html('');
    }).on('click', '.select-new__select', function () {
      var div = $(this).closest('div.select-new__info--error');
      div.removeClass('select-new__info--error');
      div.find('div.form-step__error').html('');
    });
    $(document).on('keydown', 'form[data-type]', function (event) {
      if (event.keyCode == 13) {
        $('button').prop('disabled', true);
        setTimeout(function () {
          $('button').prop('disabled', false);
        }, 500);
      }
    }).on('click', '.form-step__next', function (event) {
      event.preventDefault();
      if (event.keyCode == 13) {
        return false;
      } else {
        Step.$form = $(this).closest('form[data-type]');
        Main.showPreloader($(this));
        var type = $(this).attr('data-step');
        if (Step.checkDataTimeValidation($(this), type)) {
          if (!Step.validateStepInProgress) {
            Step.ajax.validateStep($(this));
          }
        }
      }
    }).on('click', '.form-step__back', function (event) {
      event.preventDefault();
      Step.prevStep($(this));
    }).on('click', '.final-check__edit, .activeStep', function (event) {
      event.preventDefault();
      Step.editStep($(this));
    }).on('click', '.get-data', function () {
      Step.getData();
    }).on('click', '.upload-task-file', function (e) {
      e.preventDefault();
      Step.selectFiles($(this));
    }).on('click', 'ul.upload > li[data-id] > span.remove-upload-task-photo', function (e) {
      e.preventDefault();
      Step.files.remove($(this).closest('li[data-id]').data('id'));
      $('.upload-photo__block').show();
      $('.upload-photo-btn').show();
    }).on('click', '.remove-uploaded-file', function (e) {
      e.preventDefault();
      var id = $(this).attr('data-id');
      var block = $(this).closest('li');
      Step.ajax.removeUploadedFile(id, block);
    }).on('change', '#max-helpers', function (e) {
      e.preventDefault();
      Driver.manageExtraHelperBlocks();
    }).on('change', '.booking-helper-select', function (e) {
      var hour = parseInt($('#driver_select_hours').val());
      var hoursBlock = $(this).closest('div.form-step__group').find('.booking-helper-hours');
      if (parseInt($(this).val()) === 1) {
        if (Step.distance <= 100) hoursBlock.show();
        hoursBlock.find('select').prop('disabled', false);
        if (!hour) {
          // $('#driver_select_hours option[value="1"]').prop('selected', true);
          // hoursBlock.find('select option[value="1"]').prop('selected', true);
        }
      } else {
        hoursBlock.hide();
        hoursBlock.find('select').prop('disabled', true);
      }
      Step.collectionDataForCalculatorOnTips($(this).closest('.form-step__step').find('.form-step__next').attr('data-step'));
    }).on('change', '#driver_select_hours', function (e) {
      var hour = parseInt($(this).val());
      $("select.booking-helper-hour-select option").prop('disabled', false);
      for (var item = 1; item < hour; item++) {
        $("select.booking-helper-hour-select option[value=\"".concat(item, "\"]")).prop('disabled', true);
      }
      if (!hour) {
        // $('select.booking-helper-select option[value="0"]').prop('selected', true);
        // $('select.booking-helper-select').closest('div.form-step__group').find('.booking-helper-hours').hide();
      }
      $("select.booking-helper-hour-select option[value=\"".concat(hour, "\"]")).prop('selected', true);
      Step.collectionDataForCalculatorOnTips($(this).closest('.form-step__step').find('.form-step__next').attr('data-step'));
    }).on('change', '.booking-helper-hour-select', function (e) {
      e.preventDefault();
      var hour = $(this).val();
      $("select.booking-helper-hour-select option[value=\"".concat(hour, "\"]")).prop('selected', true);
      $("select#driver_select_hours option[value=\"".concat(hour, "\"]")).prop('selected', true);
      Step.collectionDataForCalculatorOnTips($(this).closest('.form-step__step').find('.form-step__next').attr('data-step'));
    }).on('change', '#booking_special_price_check', function () {
      Step.specialPriceCheck($(this));
      Step.scrollToTop();
      Step.collectionDataForCalculatorOnTips($(this).closest('.form-step__step').find('.form-step__next').attr('data-step'));
    }).on('input paste cut', '[name="booking_special_price"]', function () {
      Step.calculateSpecialPrice($(this), false);
    }).on('blur', '[name="booking_special_price"]', function () {
      Step.calculateSpecialPrice($(this), true);
    }).on('change', '.open-task-form-as-driver-handyman', function () {
      Step.ajax.fetchTaskFormAsDriverHandyman($(this).val());
    }).on('click', '.back-to-first-step', function (event) {
      event.preventDefault();
      Step.showConfirmPhotoPopup = false;
      $('.post-not-photos-popup').removeClass('active');
      Step.editStep($('div.activeStep[data-step=1]'));
      Step.scrollToElement($('.upload-photo'));
    }).on('change', '#client_service', function (event) {
      Step.ajax.fetchRelatedServices($(this).val());
    });
  },
  nextStep: function nextStep() {
    var slidePage = $(".slide-step-2");
    var pages = $(".step-2");
    var stepsNumber = pages.length;
    var progress = $(".step-new__progress-bar");
    var progressDone = $(".step-new__progress-background");
    var bullet = $(".step-new__line");
    var bulletActive = $(".activeStep");
    var bulletDone = $(".done");
    slidePage.css('margin-left', "-".concat(100 / stepsNumber * Step.currentStep, "%"));
    bullet[Step.currentStep].classList.add("activeStep");
    bullet[Step.currentStep - 1].classList.add("done");
    Step.currentStep += 1;
    progress.css('width', "".concat((bulletActive.length + 1) / (bullet.length - 1) * 100 + '%'));
    progressDone.css('width', "".concat((bulletDone.length + 1) / (bullet.length - 1) * 100 + '%'));
    console.log('Step.currentStep', Step.currentStep);
    console.log('stepsNumber', stepsNumber);
    pages[Step.currentStep - 1].classList.add("active");
    pages[Step.currentStep - 2].classList.remove("active");
    Step.scrollToTop();
  },
  prevStep: function prevStep(button) {
    var slidePage = $(".slide-step-2");
    var pages = $(".step-2");
    var stepsNumber = pages.length;
    var progress = $(".step-new__progress-bar");
    var progressDone = $(".step-new__progress-background");
    var bullet = $(".step-new__line");
    var bulletActive = $(".activeStep");
    var bulletDone = $(".done");
    slidePage.css('margin-left', "-".concat(100 / stepsNumber * (Step.currentStep - 2), "%"));
    bullet[Step.currentStep - 1].classList.remove("activeStep");
    bullet[Step.currentStep - 2].classList.remove("done");
    progress.css('width', "".concat((bulletActive.length - 1) / (bullet.length - 1) * 100 + '%'));
    progressDone.css('width', "".concat((bulletDone.length - 1) / (bullet.length - 1) * 100 + '%'));
    pages[Step.currentStep - 2].classList.add("active");
    pages[Step.currentStep - 1].classList.remove("active");
    Step.currentStep -= 1;
    Step.scrollToTop();
    Step.collectionDataForCalculatorOnTips(button.closest('.form-step__step').prev().find('.form-step__next').attr('data-step'));
  },
  editStep: function editStep(editButton) {
    var slidePage = $(".slide-step-2");
    var pages = $(".step-2");
    var progress = $(".step-new__progress-bar");
    var progressDone = $(".step-new__progress-background");
    var bullet = $(".step-new__line");
    var bulletActive = $(".activeStep");
    var bulletDone = $(".done");
    var stepsNumber = pages.length;
    Step.currentStep = parseInt(editButton.data('step'));
    slidePage.css('margin-left', "-".concat(100 / stepsNumber * (Step.currentStep - 1), "%"));
    bullet.removeClass("activeStep");
    bulletDone.removeClass("done");
    if (Step.currentStep === 1) {
      bullet.removeClass("activeStep");
      bullet.removeClass("done");
    } else {
      for (var i = 0; i < Step.currentStep - 1; i++) {
        bullet[i].classList.add("activeStep");
        bulletDone[i].classList.add("done");
      }
    }
    bullet[Step.currentStep - 1].classList.add("activeStep");
    progress.css('width', "".concat((bulletActive.length - (bulletActive.length - Step.currentStep)) / (bullet.length - 1) * 100 + '%'));
    progressDone.css('width', "".concat((bulletDone.length - (bulletDone.length - Step.currentStep + 1)) / (bullet.length - 1) * 100 + '%'));
    pages.removeClass("active");
    pages[Step.currentStep - 1].classList.add("active");
    Step.scrollToTop();
  },
  getData: function getData() {
    var formData = $(".form-step").serializeArray();
    var elementWithValue = $('span[data-name]');
    elementWithValue.show();
    $('span[data-name-title]').show();
    $('span[data-name-title="driver_item_size"]').hide();
    $(formData).each(function (index, obj) {
      var value = obj.value;
      var name = obj.name;
      var element = $("[data-name=\"".concat(name, "\"]"));
      var field = $("[name=\"".concat(name, "\"]"));
      switch (name) {
        case 'travel_i_have_space_in':
        case 'travel_i_travel_by':
          element.html(field.next().text());
          break;
        case 'travel_per_kg':
        case 'travel_per_item':
        case 'travel_companion':
          element.html('€' + value);
          break;
        case 'driver_timing_days':
        case 'driver_timing_hours':
          element.html($("[name=\"".concat(name, "\"]:checked")).next().find('p').text());
          break;
        case 'driver_how_far_maximum_can_you_transport':
          element.html($("[name=\"".concat(name, "\"]:checked")).next().find('span').text());
          break;
        case 'driver_handyman_helpers':
          if (parseInt(value) === 0) {
            $("span[data-name-title=\"".concat(name, "\"]")).hide();
            $("span[data-name=\"".concat(name, "\"]")).hide();
          }
          element.html(value);
          break;
        case 'driver_services_provide':
        case 'driver_handyman_services_provide':
          var text = '';
          var selectedItems = field.closest('.select-driver').find('.form-step__job');
          selectedItems.each(function () {
            text = text + $(this).text() + ', ';
          });
          element.html(text.substring(0, text.length - 2));
          break;
        case 'driver_vehicle_type':
          element.html($("[name=\"".concat(name, "\"]:checked")).next().text());
          break;
        case 'driver_item_size_length':
        case 'driver_item_size_width':
        case 'driver_item_size_height':
          if (value !== '') {
            $('[data-name-title="driver_item_size"]').show();
            element.html(element.data('subtitle') + ' ' + value + ' (cm)');
          }
          break;
        case 'driver_short_distance_75_km_per_hour':
        case 'driver_short_distance_75_km_per_next_hour':
        case 'driver_short_distance_75_km_extra_helper_per_hour':
        case 'driver_long_distance_more_75_km_100__200_per_km':
        case 'driver_long_distance_more_75_km_200__500_per_km':
        case 'driver_long_distance_more_75_km_more_500_per_km':
        case 'driver_long_distance_more_75_km_extra_helper_per_day':
          element.html(element.data('subtitle') + value + '€');
          break;
        case 'driver_minimum_order_price':
          element.html(value + '€');
          break;
        case 'travel_description':
        case 'driver_handyman_comment':
          element.html(value.replace(/\n/g, '<br/>'));
          break;
        default:
          element.html(value);
          break;
      }
      if (parseInt($('#max-helpers').val()) > 0) {
        $('[data-name="driver_short_distance_75_km_extra_helper_per_hour"]').show();
        $('[data-name="driver_long_distance_more_75_km_extra_helper_per_day"]').show();
      } else {
        $('[data-name="driver_short_distance_75_km_extra_helper_per_hour"]').hide();
        $('[data-name="driver_long_distance_more_75_km_extra_helper_per_day"]').hide();
      }
    });
    elementWithValue.each(function () {
      var item = $(this);
      var title = $("[data-name-title=\"".concat(item.attr('data-name'), "\"]"));
      if (item.html() === '') {
        item.hide();
        title.hide();
      }
    });

    //for last step on driver form
    if ($('[name="driver_service_indoor"]').is(':checked') || $('[name="driver_service_outdoor"]').is(':checked')) {
      $('#handyman-price').show();
    } else {
      $('#handyman-price').hide();
    }

    //for last step on driver form
    if ($('[name="driver_service_default"]').is(':checked')) {
      $('#driver-price').show();
    } else {
      $('#driver-price').hide();
    }
  },
  scrollToTop: function scrollToTop() {
    $('html, body').animate({
      scrollTop: parseInt($("body").offset().top)
    }, 500);
  },
  scrollToError: function scrollToError(name) {
    var element = $("[name=\"".concat(name, "\"]"));
    if (element.length) {
      if (element.attr('type') === 'hidden') {
        element = element.parent();
      }
      $('html, body').animate({
        scrollTop: parseInt(element.offset().top) - 110
      }, 500);
    }
  },
  scrollToElement: function scrollToElement(element) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
    if (element.length) {
      $('html, body').animate({
        scrollTop: parseInt(element.offset().top) - offset
      }, 500);
    }
  },
  specialPriceCheck: function specialPriceCheck(element) {
    if (element.is(':checked')) {
      $('.booking-driver-special-price').show();
      element.closest('.step-2').find('.form-step__group--two').hide();
    } else {
      $('.booking-driver-special-price').hide();
      element.closest('.step-2').find('.form-step__group--two').show();
    }
  },
  setDriverHandymanHours: function setDriverHandymanHours() {
    var minHour = 1;
    var distance = Step.distance;
    if (distance < 30) minHour = 1;
    if (distance >= 30 && distance < 60) minHour = 2;
    if (distance >= 60 && distance < 100) minHour = 3;
    if (distance > 100) minHour = 0;
    for (var item = 0; item < minHour; item++) {
      $("select#driver_select_hours option[value=\"".concat(item, "\"]")).prop('disabled', true);
      $("select.booking-helper-hour-select option[value=\"".concat(item, "\"]")).prop('disabled', true);
    }
    $("select#driver_select_hours option[value=\"".concat(minHour, "\"]")).prop('selected', true);
    $("select.booking-helper-hour-select option[value=\"".concat(minHour, "\"]")).prop('selected', true);
  },
  checkDataTimeValidation: function checkDataTimeValidation(button, type) {
    Main.hidePreloader(button);
    switch (type.toString()) {
      case FORM_TYPE_CLIENT_POST_TASK__3_TRAVELER:
      case FORM_TYPE_CLIENT_POST_TASK__3_DRIVER:
      case FORM_TYPE_CLIENT_POST_TASK__2_COMPANION:
      case FORM_TYPE_CLIENT_POST_TASK__2_ALL:
      case FORM_TYPE_CLIENT_POST_TASK__2_HANDYMAN:
      case FORM_TYPE_MAKE_OFFER:
        return Client.validateDateTime(button);
      case FORM_TYPE_CLIENT_POST_TASK__1_DRIVER:
      case FORM_TYPE_CLIENT_POST_TASK__1_HANDYMAN:
        return Client.validateRelatedServices(button);
      default:
        return true;
    }
  },
  beforeSwitching: function beforeSwitching(step) {
    var button = $("button[data-step=\"".concat(step, "\"]"));
    switch (step) {
      case FORM_TYPE_REGISTER_TRAVEL__STEP_ONE:
        Travels.initFinishDatePicker();
        Step.nextStep();
        Main.hidePreloader(button);
        break;
      case FORM_TYPE_REGISTER_DRIVER__STEP_ONE:
      case FORM_TYPE_REGISTER_DRIVER__STEP_ONE__HANDYMAN:
      case FORM_TYPE_REGISTER_DRIVER__STEP_ONE__DRIVER_WITH_HANDYMAN:
        if (Driver.secondBlockAvailableForFetch) Driver.ajax.fetchBlockForSecondStepByType();
        Step.nextStep();
        Main.hidePreloader(button);
        break;
      case FORM_TYPE_REGISTER_DRIVER__STEP_TWO:
      case FORM_TYPE_REGISTER_DRIVER__STEP_TWO__HANDYMAN:
      case FORM_TYPE_REGISTER_DRIVER__STEP_TWO__DRIVER_WITH_HANDYMAN:
        if (Driver.thirdBlockAvailableForFetch) Driver.ajax.fetchBlockForThirdStepByType();
        Driver.showSelectedServicesForThirdStep();
        Step.nextStep();
        Main.hidePreloader(button);
        break;
      case FORM_TYPE_CLIENT_POST_TASK__3__COMPANION:
        if (!Step.taskPosted) Client.ajax.postTask(button);
        break;
      case FORM_TYPE_CLIENT_POST_TASK__4_TRAVELER:
      case FORM_TYPE_CLIENT_POST_TASK__3__HANDYMAN:
      case FORM_TYPE_CLIENT_POST_TASK__3__ALL:
      case FORM_TYPE_CLIENT_POST_TASK__4_DRIVER:
        if (!Step.taskPosted) {
          if ($('.open-image').length === 0 && Step.showConfirmPhotoPopup) {
            $('.post-not-photos-popup').addClass('active');
          } else {
            if (parseInt($('[name="post_task_budget_radio_buttons"]:checked').val()) === 1) {
              Client.ajax.specialDealForNewCountries(button);
            } else {
              Client.ajax.postTask(button);
            }
          }
        }
        break;
      case FORM_TYPE_CLIENT_POST_TASK__3_DRIVER:
      case FORM_TYPE_CLIENT_POST_TASK__2_COMPANION:
      case FORM_TYPE_CLIENT_POST_TASK__2_ALL:
      case FORM_TYPE_CLIENT_POST_TASK__2_HANDYMAN:
        Client.ajax.generateAiApproxBudget(button);
        Step.nextStep();
        Main.hidePreloader(button);
        break;
      // case FORM_TYPE_CLIENT_STEP_2_BOOKING__TRAVELER_COMPANION:
      case FORM_TYPE_CLIENT_STEP_3_BOOKING__TRAVELER:
      case FORM_TYPE_CLIENT_STEP_3_BOOKING__DRIVER:
      case FORM_TYPE_CLIENT_STEP_3_BOOKING__HANDYMAN:
        if ($('.open-image').length === 0 && Step.showConfirmPhotoPopup) {
          $('.post-not-photos-popup').addClass('active');
        } else {
          Client.ajax.bookService(button);
        }
        break;
      default:
        Step.nextStep();
        Main.hidePreloader(button);
        break;
    }
    Step.collectionDataForCalculatorOnTips(button.closest('.form-step__step').next().find('.form-step__next').attr('data-step'));
  },
  collectionDataForCalculatorOnTips: function collectionDataForCalculatorOnTips() {
    var _$$val, _$$val2, _$$val3, _$$val4, _$$val5, _$$val6, _$$val7, _$$val8, _$$val9, _$$val10, _$$val11, _$$val12;
    var step = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var locationFrom = (_$$val = $('[name="client_location_from"]').val()) !== null && _$$val !== void 0 ? _$$val : '';
    var locationTo = (_$$val2 = $('[name="client_location_to"]').val()) !== null && _$$val2 !== void 0 ? _$$val2 : '';
    var distance = Step.distance;
    var serviceHash = Client.serviceHash;
    var hours = (_$$val3 = $('[name="booking_driver_hours"]').val()) !== null && _$$val3 !== void 0 ? _$$val3 : 0;
    var helpers = $('select.booking-helper-select option[value="1"]:selected').length;
    var specialPriceCheck = (_$$val4 = $('[name="booking_special_price_check"]:checked').val()) !== null && _$$val4 !== void 0 ? _$$val4 : 0;
    var specialPrice = (_$$val5 = $('[name="booking_special_price"]').val()) !== null && _$$val5 !== void 0 ? _$$val5 : 0;
    var kg = (_$$val6 = $('[name="client_parcel_weight"]').val()) !== null && _$$val6 !== void 0 ? _$$val6 : 0;
    var travelDelivery = (_$$val7 = $('#travelDelivery').val()) !== null && _$$val7 !== void 0 ? _$$val7 : 0;
    var booking = (_$$val8 = $('#booking').val()) !== null && _$$val8 !== void 0 ? _$$val8 : 0;
    var travelBy = (_$$val9 = $('[name="travel_i_travel_by"]').val()) !== null && _$$val9 !== void 0 ? _$$val9 : 1;
    var driverCheck = (_$$val10 = $('[name="driver_service_default"]:checked').val()) !== null && _$$val10 !== void 0 ? _$$val10 : 0;
    var indoorCheck = (_$$val11 = $('[name="driver_service_indoor"]:checked').val()) !== null && _$$val11 !== void 0 ? _$$val11 : 0;
    var outdoorCheck = (_$$val12 = $('[name="driver_service_outdoor"]:checked').val()) !== null && _$$val12 !== void 0 ? _$$val12 : 0;
    if (step) Step.ajax.fetchCalculatorOnTips(step, locationFrom, locationTo, distance, serviceHash, hours, helpers, specialPriceCheck, specialPrice, kg, travelDelivery, booking, travelBy, driverCheck, indoorCheck, outdoorCheck);
  },
  calculateSpecialPrice: function calculateSpecialPrice(input, changeVal) {
    var total = 0;
    var amount = parseFloat(input.val());
    var minOrderValue = parseFloat(input.attr('data-min'));
    var minPercent = parseFloat(input.attr('data-percent'));
    var minPrice = (minOrderValue * (1 - minPercent)).toFixed(2);
    var serviceFeesField = $('#service-fees');
    var servicePriceField = $('#special-price');
    var totalPriceField = $('#total-price');
    if (isNaN(amount) || amount < minPrice) {
      total = parseFloat(minPrice).toFixed(2);
      if (changeVal) input.val(total);
    } else {
      total = amount.toFixed(2);
    }
    var fees = parseFloat(total < 150 ? 8 : (total * 0.05).toFixed(2));
    fees = (fees + fees * 0.19).toFixed(2);
    var totalWithCommission = parseFloat(total) + parseFloat(fees);
    serviceFeesField.text(fees);
    servicePriceField.text(total);
    totalPriceField.text(totalWithCommission.toFixed(2));
  },
  preloaderUpload: function preloaderUpload(e, preloderCount) {
    var textBlock = $('.upload-photo__text');
    var progressBlock = $('.upload-photo__progress');
    var progress = document.getElementById("upload-photo__progress-bar");
    var progressCount = document.getElementById("upload-photo__progress-count");
    var stepValue = 0;
    var i = e.target;
    textBlock.hide();
    progressBlock.show();
    var set;
    if (preloderCount) {
      set = setInterval(fakeProgress, 200);
    } else {
      set = setInterval(fakeProgress, 700);
    }
    function fakeProgress() {
      if (stepValue >= 100) {
        clearInterval(set);
        textBlock.show();
        progressBlock.hide();
        progress.style.width = stepValue + "%";
        progressCount.innerHTML = stepValue + "%";
        stepValue = stepValue;
      } else {
        progress.style.width = stepValue + 20 + "%";
        progressCount.innerHTML = stepValue + 20 + "%";
        stepValue = stepValue + 20;
      }
    }
  },
  showErrors: function showErrors(name, value) {
    var field = $("[name=\"".concat(name, "\"]"));
    var div = field.closest('div.form-step__input');
    switch (name) {
      case 'travel_i_have_space_in':
      case 'travel_i_travel_by':
        div.addClass('select-new__info--error');
        div.find('div.form-step__error').show().html(value);
        break;
      case 'driver_handyman_services_provide':
      case 'driver_services_provide':
        field.closest('.select-driver__wrapper').addClass('error');
        field.closest('.select-driver__wrapper').find('.select-driver__error').html(value);
        break;
      case 'driver_vehicle_type':
        field.closest('.type-cars').addClass('error');
        field.closest('.type-cars').find('.type-cars__error').html(value);
        break;
      case 'driver_handyman_info':
      case 'driver_vehicle_information':
      case 'driver_country':
      case 'driver_city':
      case 'driver_street':
      case 'driver_address':
      case 'driver_vehicle_name':
      case 'client_service':
      case 'client_task_name':
      case 'client_list_of_items':
      case 'client_location_from':
      case 'client_location_to':
      case 'client_must_haves':
      case 'client_parcel_weight':
      case 'client_pick_up_location':
      case 'client_drop_off_location':
        div.addClass('error');
        div.find('div.form-step__error').show().html(value);
        break;
      case 'reviewRating':
        field.closest('div').addClass('error');
        field.closest('div').find('div.form-pop-up__error').show().html(value);
        break;
      case 'files':
        $('.upload-photo').addClass('error');
        $('.upload-photo__error').html(value);
        break;
      case 'driver_timing_days':
      case 'driver_timing_hours':
      case 'driver_how_far_maximum_can_you_transport':
      case 'client_how_traveler_will_get_an_item':
        field.closest('.form-step__group').addClass('error');
        field.closest('.form-step__group').find('.form-step__error').html(value);
        break;
      case 'driver_i_have_a_valid_driving_license':
      case 'driver_i_have_a_valid_driving_liability':
      case 'driver_i_have_a_valid_handyman_certificates':
      case 'driver_i_have_a_valid_professional_driver_certificates':
        field.closest('.form-step__input').addClass('form-step__input--checkbox-error');
        break;
      case 'make_offer_amount':
      case 'make_offer_message':
        field.closest('div').addClass('error');
        field.next().text(value);
        break;
      case 'billing_data_offer_id':
      case 'billing_data_first_name':
      case 'billing_data_last_name':
      case 'billing_data_address':
      case 'billing_data_company':
      case 'billing_data_post_code':
      case 'billing_data_city':
      case 'billing_data_country':
        field.closest('.form-billing__input').addClass('error');
        field.closest('.form-billing__input').find('.form-billing__error').html(value);
        break;
      case 'payout_first_name':
      case 'payout_last_name':
      case 'payout_date':
      case 'payout_address_1':
      case 'payout_address_2':
      case 'payout_hsbc':
      case 'payout_post_code':
      case 'payout_country':
      case 'payout_city':
      case 'payout_bank_country':
      case 'payout_iban':
      case 'payout_swift':
      case 'payout_site':
        field.closest('.personal-info-form__input').addClass('error');
        field.closest('.personal-info-form__input').find('.personal-info-form__error').html(value);
        break;
      case 'payout_check':
        field.closest('.personal-info-form__detail').addClass('personal-info-form__detail-error');
        break;
      case 'profile_first_name':
      case 'profile_last_name':
      case 'profile_country':
      case 'state':
      case 'profile_city':
      case 'profile_street':
      case 'profile_postal_code':
      case 'old-password':
      case 'new-password':
      case 'confirm-password':
        field.closest('.form-element').find('.error').show().text(value);
        break;
      case 'offer_cancel_reason_text':
        field.closest('div').addClass('error').find('.form-pop-up__error').show().text(value);
        break;
      case 'offer_cancel_reason':
        field.closest('div').addClass('error').find('.form-pop-up__error').show().text(value);
        break;
      case 'offer_agree_policy':
        $('[name="offer_agree_policy"]').closest('div.form-pop-up__input').addClass('checked-error-popup');
        break;
      case 'feedback_client_type':
      case 'feedback_subject':
        field.closest('div.form-feedback__select').addClass('error').find('.form-feedback__error').text(value);
        break;
      case 'feedback_comment':
        field.closest('div.form-feedback__textarea').find('.form-feedback__error').text(value);
        break;
      case 'businessVehicleSize':
      case 'businessLatFrom':
      case 'businessLngFrom':
      case 'businessCountryFrom':
      case 'businessAddressFrom':
      case 'businessLatTo':
      case 'businessLngTo':
      case 'businessCountryTo':
      case 'businessAddressTo':
      case 'businessEmail':
      case 'businessFirstName':
      case 'businessMessage':
      case 'businessLastName':
      case 'businessContactTheme':
      case 'businessDate':
        field.closest('div.form-element').find('p.error').text(value);
        field.closest('div.form-element').find('p.error').show();
        break;
      case 'businessHelpHours':
        field.closest('div.calculate-block').next().find('p.error').text(value);
        field.closest('div.calculate-block').next().find('p.error').show();
        break;
      case 'businessHelpServices':
        field.closest('div.select-services__wrapper').find('.select-services__error').text(value);
        field.closest('div.select-services__wrapper').find('.select-services__error').show();
        break;
      default:
        div.addClass('form-step__input--error');
        div.find('div.form-step__error').show().html(value);
        break;
    }
  },
  selectFiles: function selectFiles(element) {
    var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;
    Step.$form = element.closest('form');
    var $input = $('<input type="file" accept=".png, .jpg, .jpeg, .HEIC" multiple>').on('change', function (event) {
      var fileName = this.files[0];
      var fileNameExt = fileName.name.substr(fileName.name.lastIndexOf('.') + 1);
      var preloaderCount = true;
      if (fileNameExt == "heic" || fileNameExt == "HEIC") {
        var thisInput = this;
        preloaderCount = false;
        Step.preloaderUpload(event, preloaderCount);
        heic2any({
          blob: fileName,
          toType: "image/jpeg",
          quality: 0.5
        }).then(function (result) {
          var container = new DataTransfer();
          var fileJpeg = new File([result], fileName.name + ".jpg", {
            type: "image/jpeg",
            lastModified: new Date().getTime()
          });
          container.items.add(fileJpeg);
          $.each(thisInput.files, function (k) {
            if (fileJpeg.size < Step.maxFileSize && Driver.files.list.length < max) {
              Step.files.add(container.files[0]);
              Step.previewFiles.push(URL.createObjectURL(result));
            }
          });
        })["catch"](function (x) {
          console.log('Error');
        });
      } else {
        preloaderCount = true;
        Step.preloaderUpload(event, preloaderCount);
        $.each(this.files, function (k, v) {
          if (v.size < Step.maxFileSize && Driver.files.list.length < max) {
            Step.files.add(v);
            Step.previewFiles.push(URL.createObjectURL(event.target.files[k]));
          }
        });
      }
      $input.remove();
      if (Step.files.list.length > max - 1) {
        $('.upload-photo__block').hide();
        $('.upload-photo-btn').hide();
      } else {
        Step.preloaderUpload(event);
      }
      $('.upload-photo').removeClass('error');
      $('.upload-photo__error').html('');
    }).hide();
    $(document.body).append($input);
    $input.click();
  },
  files: {
    list: [],
    $fileList: undefined,
    $progress: undefined,
    add: function add(file) {
      this.list.push(file);
      this.refreshList();
    },
    remove: function remove(key) {
      this.list.splice(key, 1);
      Step.previewFiles.splice(key, 1);
      this.refreshList();
    },
    refreshList: function refreshList(callback) {
      this.$fileList = Step.$form.find('ul.upload').fadeOut('fast', function () {
        $(this).children('li[data-id]').remove();
        $.each(Step.files.list, function (k, v) {
          Step.files.$fileList.append($('<li>').attr('data-id', k).append($('<img>').addClass('open-image').attr('src', Step.previewFiles[k])).append('<span class="upload-photo__remove remove-upload-task-photo"><svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg"><ellipse cx="10.5" cy="10" rx="10.5" ry="10" fill="white" fill-opacity="0.8"/><path d="M6 5L11 10M16 15L11 10M11 10L16 5M11 10L6 15" stroke="#EB5757" stroke-width="2"/></svg>\n</span>'));
        });
        $(this).fadeIn('fast', function () {
          typeof callback === 'function' ? callback() : null;
        });
      });
    },
    upload: function upload() {
      if (this.list.length > 0) {
        Step.ajax.uploadFilesForTask(this.list.shift());
      } else {
        if (Step.postTaskAsGuest) {
          window.location.replace(Step.callbackUrl);
        } else {
          var thankYouPage = $('div.thank-form-step');
          var thankYouPageWrapper = $('div.thank-form-step-wrapper');
          thankYouPageWrapper.css('display', 'block');
          thankYouPage.css('display', 'flex');
          $('div.offer__container').hide();
          $('.need-fast-offer').addClass('active');
          $('.answer-question-coupon').addClass('active');
          Step.scrollToTop();
        }
      }
    },
    uploadAllFiles: function uploadAllFiles() {
      if (this.list.length > 0) {
        // Step.ajax.uploadFilesForTask(this.list.shift());

        var formData = new FormData();
        formData.append('method', 'uploadAllFiles');
        formData.append('id', Step.taskID);
        $.each(this.list, function (i, file) {
          formData.append('file_' + i, file);
        });
        $.ajax({
          url: AJAX_URL,
          type: 'POST',
          data: formData,
          contentType: false,
          processData: false,
          success: function success() {
            Step.files.list = [];
            Step.files.uploadAllFiles();
          },
          error: function error() {
            console.log('Error');
          }
        });
      } else {
        if (Step.postTaskAsGuest) {
          window.location.replace(Step.callbackUrl);
        } else {
          var thankYouPage = $('div.thank-form-step');
          var thankYouPageWrapper = $('div.thank-form-step-wrapper');
          thankYouPageWrapper.css('display', 'block');
          thankYouPage.css('display', 'flex');
          $('div.offer__container').hide();
          $('.need-fast-offer').addClass('active');
          $('.answer-question-coupon').addClass('active');
          Step.scrollToTop();
        }
      }
    }
  },
  ajax: {
    obj: {},
    url: AJAX_URL,
    send: function send(success, failure) {
      var _this = this;
      $.post(this.url, this.obj, function (answer) {
        _this.obj = {};
        answer.result && typeof success === 'function' ? success(answer) : !answer.result && typeof failure === 'function' ? failure(answer) : null;
      }, 'JSON').fail(function (jqXHR, textStatus, errorThrown) {
        if (jqXHR.status === 0) {
          console.error("NETWORK ERROR: net::ERR_NETWORK_DISCONNECTED");
          Step.validateStepInProgress = false;
        } else {
          console.error("Error: " + textStatus + " - " + errorThrown);
        }
      });
    },
    validateStep: function validateStep(button) {
      Step.validateStepInProgress = true;
      var step = button.attr('data-step');
      this.obj.method = 'validateStep';
      this.obj.step = step;
      this.obj.data = button.closest("div[data-step]").find(':input').serializeArray();
      this.obj.checkFiles = $('.open-image').length;
      this.send(function (answer) {
        Step.validateStepInProgress = false;
        Step.beforeSwitching(step, button);
      }, function (answer) {
        Step.validateStepInProgress = false;
        $.each(answer.errors, function (name, value) {
          Step.showErrors(name, value);
        });
        console.table(answer.errors);
        if (Object.keys(answer.errors).length) Step.scrollToError(Object.keys(answer.errors)[0]);
        Main.hidePreloader(button);
      });
    },
    removeUploadedFile: function removeUploadedFile(id, block) {
      this.obj.method = 'removeUploadedFile';
      this.obj.id = id;
      this.send(function () {
        block.remove();
      }, function () {
        console.log('Error');
      });
    },
    uploadFilesForTask: function uploadFilesForTask(file) {
      var formData = new FormData();
      formData.append('method', 'uploadFilesForTask');
      formData.append('id', Step.taskID);
      formData.append('file', file);
      $.ajax({
        url: AJAX_URL,
        type: 'POST',
        data: formData,
        contentType: false,
        processData: false,
        success: function success() {
          Step.files.upload();
        },
        error: function error() {
          console.log('Error');
        }
      });
    },
    getDistance: function getDistance() {
      this.obj.method = 'getDistance';
      this.obj.from = $('[name="client_location_from"]').val();
      this.obj.to = $('[name="client_location_to"]').val();
      this.send(function (answer) {
        Step.distance = parseInt(answer.distance);
        Step.setDriverHandymanHours();
        $('.tips-distance').html(Step.distance);
      }, function () {
        Step.distance = 150;
      });
    },
    fetchCalculatorOnTips: function fetchCalculatorOnTips(step, locationFrom, locationTo, distance, serviceHash, hours, helpers, specialPriceCheck, specialPrice, kg, travelDelivery, booking, travelBy, driverCheck, indoorCheck, outdoorCheck) {
      this.obj.method = 'fetchCalculatorOnTips';
      this.obj.step = step;
      this.obj.locationFrom = locationFrom;
      this.obj.locationTo = locationTo;
      this.obj.distance = Step.distance;
      this.obj.serviceHash = serviceHash;
      this.obj.hours = hours;
      this.obj.helpers = helpers;
      this.obj.specialPriceCheck = specialPriceCheck;
      this.obj.specialPrice = specialPrice;
      this.obj.kg = kg;
      this.obj.travelDelivery = travelDelivery;
      this.obj.booking = booking;
      this.obj.travelBy = travelBy;
      this.obj.driverCheck = driverCheck;
      this.obj.indoorCheck = indoorCheck;
      this.obj.outdoorCheck = outdoorCheck;
      this.send(function (answer) {
        $('#block-with-tips').html(answer.html);
        Main.showHoverPopup();
        Main.showTips();
        console.log('answer ', answer);
        console.log('answer.total ', answer.total);
        $('[name="booking_special_price"]').val(answer.total).attr('data-min', answer.total);
        Step.calculateSpecialPrice($('[name="booking_special_price"]'), true);
        if (step === FORM_TYPE_CLIENT_POST_TASK__3_DRIVER) {
          Step.ajax.getDistance();
        } else if (step === FORM_TYPE_CLIENT_STEP_3_BOOKING__DRIVER_HANDYMAN) {
          Step.specialPriceCheck();
        }
      }, function () {
        console.log('Error');
      });
    },
    fetchTaskFormAsDriverHandyman: function fetchTaskFormAsDriverHandyman(serviceID) {
      this.obj.method = 'fetchTaskFormAsDriverHandyman';
      this.obj.hash = Client.hash;
      this.obj.serviceHash = Client.serviceHash;
      this.obj.edit = Client.edit;
      this.obj.serviceID = serviceID;
      this.send(function (answer) {
        $('#booking-service-form').html(answer.html);
        Autocomplete.googleAutocompleteForClient.autocompleteField();
      }, function (answer) {
        console.log('Error');
      });
    },
    fetchRelatedServices: function fetchRelatedServices(serviceID) {
      this.obj.method = 'fetchRelatedServices';
      this.obj.hash = Client.hash;
      this.obj.serviceID = serviceID;
      this.send(function (answer) {
        $('.related-categories').html(answer.html);
      }, function (answer) {
        console.log('Error');
      });
    }
  }
};